import { useContext, useEffect, useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import { AuthUserContext } from '@yakoffice/yakoffice-firebase';
import { ClaimType } from '@yakoffice/publisher-types';
import { IClaimVm, IResponse } from '@yakoffice/publisher-types';
import { pub_api } from './pubApi';

export interface PublisherClaimsResult {
    isLoaded: boolean;
    result: {
        editSelections: boolean;
        editGameEnvironments: boolean;
        editGameVersions: boolean;
    } | null;
}

export const usePublisherClaims = (projectId: string) => {

    const authUser = useContext(AuthUserContext);
    const [result, setResult] = useState<PublisherClaimsResult>({ isLoaded: false, result: null });

    useEffect(() => {

        setResult({ isLoaded: false, result: null });

        if (!authUser?.firebaseUser)
            return;

        authUser.firebaseUser.getIdToken().then(token => {
            axios
                .get<IResponse<IClaimVm[]>>(`${pub_api}/claims`, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                })
                .then((res: AxiosResponse<IResponse<IClaimVm[]>>) => {
                    if (res.status === 200) {

                        const mappedResult = {
                            editSelections: !!res.data.data.find(claim => claim.type === ClaimType.EditSelection && claim.value === projectId),
                            editGameEnvironments: !!res.data.data.find(claim => claim.type === ClaimType.EditGameEnvironment && claim.value === projectId),
                            editGameVersions: !!res.data.data.find(claim => claim.type === ClaimType.EditGameVersion && claim.value === projectId)
                        };

                        setResult({ isLoaded: true, result: mappedResult });
                    } else {
                        console.log(`Authorisation failed.  Status code: ${res.status}, Status text: ${res.statusText}`);
                        setResult({ isLoaded: true, result: null });
                    }
                })
                .catch((error: any) => {
                    console.error(error);
                    setResult({ isLoaded: true, result: null });
                });
        });
    }, [authUser?.firebaseUser]);

    return result;
};
